module.exports = __webpack_public_path__ + "img/TV_clean_box10.92e5b7ea.jpg";